import { Browser, Device, Version } from "@kakaopay-common/user-agent";
import "../interface/appUserId.mjs";
import "@kakaopay-common/payweb-core";
import "../constants.mjs";
import "../interface/openFaq.mjs";
import "../interface/openCS.mjs";
import "../interface/openNotice.mjs";
import "../interface/openPrivateAsk.mjs";
import "lodash.merge";
import "../interface/ViewControl/scrollBounces.mjs";
import { getSelectedTabIndex } from "../interface/TabView/getSelectedTabIndex.mjs";
function isSelectedTabEnabledVersion() {
  const currentVersion = Browser.getAppVersion();
  return Device.isAndroid() && (Browser.isKakaoPayApp() && Version.isGreaterThanOrEqualTo(currentVersion, "2.22.0") || Browser.isKakaoTalkApp() && Version.isGreaterThanOrEqualTo(currentVersion, "10.3.0"));
}
function checkCurrentTabSelected() {
  return getSelectedTabIndex().then((res) => {
    if (res.result.index === Browser.getTabIndex()) {
      return Promise.resolve();
    }
    return Promise.reject();
  });
}
export {
  checkCurrentTabSelected,
  isSelectedTabEnabledVersion
};
